module.exports = __webpack_public_path__ + "img/item-2.b6cb043.png";